<template>
    <div class="survey">
        <div class="mb-2">
            <h5 class="title is-5">{{ title }}</h5>
            <h6 class="subtitle is-6">{{ templateTitle }}</h6>
        </div>
        <div v-for="section in sections" :key="section.id">
            <Section :section="section" />
        </div>
    </div>
</template>

<script>
import Section from "./Section.vue";

export default {
    name: "survey-viewer",
    components: {
        Section,
    },
    props: {
        survey: {
            type: Object,
            required: true,
        },
    },
    computed: {
        sections() {
            return this.survey.template.sections;
        },
        title() {
            return this.survey.title;
        },
        templateTitle() {
            return this.survey.template.title;
        },
    },
};
</script>

<style lang="scss" scoped>
.survey {
    max-height: 75vh;
    overflow-y: auto;
    margin: 1rem;
}
</style>